import {ReplyEntry, UpdateQnaReplyApiProps} from "../../../../types/support/qna";
import {useEditQnaReply} from "../hooks/useEditQnaReply";
import ReplyEditRow from "../../../../components/common/ReplyEditRow";

interface ReplyEditRowProps {
    data: ReplyEntry;
    onCanceled: (key:string) => void;
    qnaId: string;
}

export default function QnaReplyEditRow(props: ReplyEditRowProps) {
    const {data, onCanceled, qnaId} = props;

    const {
        removeFile,
        handleButtonClick,
        UploadUI,
        inputData,
        setInputData,
        updateQnaReply
    } = useEditQnaReply({data: data, onCanceled, qnaId: qnaId});

    return <ReplyEditRow setter={setInputData}
                         data={inputData}
                         removeFile={removeFile}
                         handleButtonClick={handleButtonClick}
                         UploadUI={UploadUI}
                         updateReply={()=>updateQnaReply(inputData as UpdateQnaReplyApiProps)}
                         onCanceled={()=>onCanceled(inputData.qnaReplyId)}/>
}